/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  BreakpointQueryName, Grid, HStack, Spacing, Stack,
} from '@doveit/bricks';
import { useTheme } from 'styled-components';
import { useMediaQuery } from 'styled-breakpoints/use-media-query';
import * as styles from './RightColumnPageLayout.style';
import SimplePageLayout, { SimplePageLayoutProps } from '../simple-page-layout/SimplePageLayout';

export interface RightColumnPageLayoutProps extends React.AriaAttributes, Pick<SimplePageLayoutProps, 'header' | 'toolbar' | 'footer'>, React.PropsWithChildren {
  title?: React.ReactNode,
  topContent?: React.ReactNode,
  sidePrimaryContent: React.ReactNode,
  sideSecondaryContent?: React.ReactNode,
  actions?: React.ReactNode,
}

const RightColumnPageLayout: React.FC<RightColumnPageLayoutProps> = ({
  title,
  actions = [],
  topContent,
  sidePrimaryContent,
  sideSecondaryContent,
  footer,
  children,
  ...rest
}) => {
  const theme = useTheme();
  const isTabletOrBigger = useMediaQuery(theme.breakpoints.up(BreakpointQueryName.XL));

  return (
    <SimplePageLayout
      {...rest}
      header={(
        <HStack
          alignItems="center"
          justifyContent="space-between"
          wrap="nowrap"
          gap={200}
        >
          <div css={styles.headerTitle}>
            {title}
          </div>
          {actions && (
            <div css={styles.headerActions}>
              <HStack>
                {actions}
              </HStack>
            </div>
          )}
        </HStack>
      )}
      footer={footer}
    >
      {!isTabletOrBigger && topContent && (
        <Spacing margin={[0, 0, 300]}>
          {topContent}
        </Spacing>
      )}
      <Grid gutter={200}>
        <Grid.Unit size={{ XL: 2 / 3 }}>
          <Stack gap={300}>
            {isTabletOrBigger && topContent}
            {!isTabletOrBigger && sidePrimaryContent}
            {children}
          </Stack>
        </Grid.Unit>
        <Grid.Unit size={{ XL: 1 / 3 }}>
          <Stack gap={300}>
            {isTabletOrBigger && sidePrimaryContent}
            {sideSecondaryContent}
          </Stack>
        </Grid.Unit>
      </Grid>
    </SimplePageLayout>
  );
};

export default RightColumnPageLayout;
